import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import OurWork from "@/pages/OurWork";
import Approach from "@/pages/Approach";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Funding from "@/pages/Funding";
import Resources from "@/pages/Resources";
import ProjectFunding from "@/pages/ProjectFunding";
import CapitalPartners from "@/pages/CapitalPartners";
import BeyondGrants from "@/pages/BeyondGrants";
import CommonGround from "@/pages/CommonGround";
import CommunityFood from "@/pages/CommunityFood";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Let the route render, then scroll to the anchored section. Re-scroll
      // once all resources finish loading so image layout shift can't leave
      // the page short of the target (slow mobile connections).
      const scroll = () => {
        const el = document.getElementById(hash.slice(1));
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      const t1 = setTimeout(scroll, 100);
      const t2 = setTimeout(scroll, 900);
      window.addEventListener("load", scroll);
      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
        window.removeEventListener("load", scroll);
      };
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-cream text-charcoal">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-work" element={<OurWork />} />
            <Route path="/our-work/common-ground" element={<CommonGround />} />
            <Route path="/our-work/community-food-enterprise" element={<CommunityFood />} />
            <Route path="/funding" element={<Funding />} />
            <Route path="/funding/projects" element={<ProjectFunding />} />
            <Route path="/funding/beyond-grants" element={<BeyondGrants />} />
            <Route path="/capital-partners" element={<CapitalPartners />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/approach" element={<Approach />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster position="bottom-center" richColors />
    </BrowserRouter>
  );
}

export default App;
